module.exports = __webpack_public_path__ + "img/close.ca2824bd.svg";